var collapsible_list_component_rtlignore_default = {
  "ltr": "NwuaZ",
  "rtl": "EuKYg",
  "iconContainer": "YA0oE",
  "icon": "dkIJ-",
  "isExpanded": "VttiI",
  "listDimensions": "SQdYe"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
